if (!customElements.get('thaani-packs')) {
  customElements.define('thaani-packs', class extends HTMLElement {
    connectedCallback() {
      this.productInfo = this.closest('product-info');
      if (!this.productInfo) return;
      this.buttons = [...this.querySelectorAll('[data-quantity]')];
      this.breaks = JSON.parse(this.querySelector('[data-breaks]').textContent || '[]');
      this.plans = JSON.parse(this.querySelector('[data-plans]').textContent || '[]');
      this.onChange = () => this.sync();
      this.onClick = (event) => {
        const button = event.target.closest('[data-quantity]');
        const input = this.input;
        if (!button || button.disabled || !input) return;
        input.value = button.dataset.quantity;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      };
      this.addEventListener('click', this.onClick);
      this.productInfo.addEventListener('change', this.onChange);
      this.onRules = () => this.sync();
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribeRules = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.onRules);
      }
      this.frame = requestAnimationFrame(() => this.sync());
    }
    get input() { return this.productInfo?.querySelector('.quantity__input'); }
    sync() {
      const input = this.input;
      if (!input) return;
      const min = Number(input.min) || 1;
      const max = input.max ? Number(input.max) : Infinity;
      const step = Number(input.step) || 1;
      const selectedPlan = this.productInfo.querySelector('[name="selling_plan"]:checked')?.value;
      const allocation = this.plans.find((item) => String(item.selling_plan.id) === selectedPlan);
      const base = Number(this.dataset.price);
      const portions = Number(this.dataset.portions) || 0;
      const portionLabel = this.dataset.portionLabel || '';
      const cartQuantity = Number(input.dataset.cartQuantity) || 0;
      const selectedButton = this.buttons.find((button) => button.dataset.quantity === input.value);
      const selectedLabel = this.querySelector('[data-selected-label]');
      if (selectedLabel) selectedLabel.textContent = selectedButton?.querySelector('[data-pack-label]')?.textContent || input.value;
      const formatter = new Intl.NumberFormat(this.dataset.locale || 'de-CH', { style: 'currency', currency: this.dataset.currency || 'CHF' });
      this.buttons.forEach((button) => {
        const quantity = Number(button.dataset.quantity);
        button.disabled = quantity < min || quantity > max || (quantity - min) % step !== 0;
        button.setAttribute('aria-pressed', String(Number(input.value) === quantity));
        let price = allocation ? allocation.price : base;
        if (!allocation) {
          const eligible = this.breaks.filter((item) => item.minimum_quantity <= cartQuantity + quantity).sort((a, b) => b.minimum_quantity - a.minimum_quantity);
          if (eligible.length) price = eligible[0].price;
        }
        button.querySelector('[data-total]').textContent = formatter.format(price * quantity / 100);
        const portion = button.querySelector('[data-portion]');
        if (portion && portions > 0) {
          portion.textContent = `${formatter.format(price / portions / 100)} ${portionLabel}`.trim();
        }
        const saving = button.querySelector('[data-saving]');
        const popular = button.querySelector('[data-popular]');
        const percent = base > 0 ? Math.floor((base - price) / base * 100) : 0;
        if (saving) {
          saving.hidden = percent <= 0;
          saving.textContent = percent > 0 ? `−${percent} %` : '';
        }
        // Ein echter Rabatt ist konkreter als "Beliebt": dann nur das Sparbadge zeigen.
        if (popular) popular.hidden = percent > 0;
      });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.removeEventListener('click', this.onClick);
      this.productInfo?.removeEventListener('change', this.onChange);
      this.unsubscribeRules?.();
    }
  });
}
